import { c as _c } from "react/compiler-runtime";
import type { HistoryEventItem } from '../history-utils/types.ts';
import { HistoryDescription } from './history-description.tsx';
import { HistoryRow } from './history-row.tsx';
import { useHistoryEntity } from '../history-utils/entity.ts';
import { getEventLabel } from '../history-utils/labels.ts';
export const EventRow = t0 => {
  const $ = _c(9);
  const {
    item
  } = t0;
  const {
    entry
  } = item;
  const entity = useHistoryEntity();
  let t1;
  if ($[0] !== entity || $[1] !== entry) {
    t1 = getEventLabel(entry, entity);
    $[0] = entity;
    $[1] = entry;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== entry) {
    t2 = <div className="min-w-0 text-base leading-6 break-words text-muted-foreground @4xl/history:col-span-4"><HistoryDescription entry={entry} fallback="-" data-sentry-element="HistoryDescription" data-sentry-source-file="history-event-row.tsx" /></div>;
    $[3] = entry;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== entry || $[6] !== t1 || $[7] !== t2) {
    t3 = <HistoryRow entry={entry} title={t1} data-sentry-element="HistoryRow" data-sentry-component="EventRow" data-sentry-source-file="history-event-row.tsx">{t2}</HistoryRow>;
    $[5] = entry;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};